/**
 * 模組頁面代碼 : 1310-UI-04
 * 頁面說明 : 梯控設定列表畫面
 * @module web/modules/building/components/BuildingListModal
 */


// ----- import from npm modules ----
import $ from 'jquery';
import React, { useEffect } from 'react';

// ----- import from local modules -----
import {
    AccessModeEnums,
    ModuleEnums,
} from '../../../components/BaseComponent';
import {
    DataTableComponent,
} from '../../../components/CommonComponent';
import { AlertModalModeEnums } from 'web/components/AlertModal';

const ControlDeviceListModal = React.forwardRef((props, ref) => {
    const { checkPermission, building, onNewControlDevice, onEditControlDevice, onDeleteControlDevice, onEditControlDeviceStatus, controlDeviceList,
        needControlDeviceListLoad, setNeedControlDeviceListLoad } = props;

    const prepareControlDeviceListTable = () => {
        // 定義資料內容
        const dataSet = controlDeviceList.map((controlDevice) => {
            return [
                controlDevice.deviceName,
                controlDevice.deviceType,
                controlDevice.deviceCode,
                controlDevice.flgStatus
            ];
        });

        // 定義欄位屬性
        const columnConfig = [
            { title: '梯控裝置名稱', data: 0 },
            { title: '設定類型', data: 1 },
            { title: '設定控制碼', data: 2 },
            {
                orderable: false,
                order: null,
                title: '啟用',
                data: 3,
                className: 'dt-center',
                render: (data, type, row, meta) => {
                    let enableId = 'eab-device-' + meta.row;
                    let isChecked = data === 'A' ? 'checked' : '';
                    let enableButton = checkPermission(ModuleEnums.DEVICE, AccessModeEnums.DELETE) ? '' : 'disabled';
                    return `<div class="form-check form-switch">
                               <input class="form-check-input" type="checkbox" role="switch" id="${enableId}" ${isChecked} ${enableButton} />
                               <label class="form-check-label" for="${enableId}"></label>
                            </div>`;
                },
            },
            {
                orderable: false,
                order: null,
                data: null,
                className: 'dt-right',
                render: (data, type, row, meta) => {
                    let editId = 'edit-device-' + meta.row;
                    let deleId = 'del-device-' + meta.row
                    let editButton = checkPermission(ModuleEnums.DEVICE, AccessModeEnums.UPDATE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${editId}">
                            <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                                <use href="#ico-edit"></use>
                            </svg>
                            修改
                        </button>` : '';
                    let deleteButton = checkPermission(ModuleEnums.DEVICE, AccessModeEnums.DELETE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${deleId}">
                            刪除
                        </button>` : '';
                    return `<div class="btn-group" role="group" aria-label="">
                                ${editButton}
                                ${deleteButton}
                            </div>`;
                },
            },
        ];

        // 定義排序設定
        const orderConfig = {
            idx: 0,
            dir: 'asc',
        };

        // 定義固定欄位設定
        const fixedColumnsConfig = {
            start: 1,
        };

        // 先清除datatable
        if ($.fn.DataTable.isDataTable('#datatable__controlDeviceList')) {
            $('#datatable__controlDeviceList').DataTable().destroy();
            $('#datatable__controlDeviceList').empty();
        }
        
        return DataTableComponent('#datatable__controlDeviceList', dataSet, columnConfig, orderConfig, fixedColumnsConfig);
    };

    // 當表格的容器可見後，調整列寬
    const adjustTableWhenVisible = () => {
        const tableContainer = document.querySelector('#datatable__controlDeviceList'); // 假設這是表格的容器
        if (tableContainer && tableContainer.offsetParent !== null) {
            let t = prepareControlDeviceListTable();
            t.columns.adjust().draw();
        } else {
            setTimeout(adjustTableWhenVisible, 100); // 容器不可見，稍後再嘗試
        }
    };

    useEffect(() => {
        if (needControlDeviceListLoad) {
            setNeedControlDeviceListLoad(false);

            const maskElement = document.querySelector('#modal-mask');
            // 顯示遮罩
            maskElement.style.opacity = '0.5';

            // 重新繪製表格
            adjustTableWhenVisible();

            // 隱藏遮罩
            maskElement.style.opacity = '0'
            setTimeout(() => {
               maskElement.style.display = 'none'
            }, 200);

            if (ref.current) {
                ref.current.addEventListener('click', function (event) {
                    const button = event.target.closest('.btn');
                    if (button && button.id.startsWith('edit-device-')) {
                        onEditControlDevice(parseInt(button.id.split('-')[2]));
                    }
                });
                ref.current.addEventListener('click', function (event) {
                    const button = event.target.closest('.btn');
                    if (button && button.id.startsWith('del-device-')) {
                        const index = parseInt(button.id.split('-')[2]);
                        const delControlDevice = controlDeviceList[index];
                        if (delControlDevice) {
                            const deviceId = delControlDevice.deviceId;
                            const message = `確定要刪除 [ ${delControlDevice.deviceName} ] 梯控設備資料嗎？`;
                            onDeleteControlDevice(message, deviceId);
                        } else {
                            console.log('No device found at index:', index);
                        }
                    }
                });
                ref.current.addEventListener('change', function (event) {
                    const checkbox = event.target.closest('input[type="checkbox"]');
                    if (checkbox && checkbox.id.startsWith('eab-device-')) {
                        const index = parseInt(checkbox.id.split('-')[2]);
                        const mode = checkbox.checked ? AlertModalModeEnums.ENABLE : AlertModalModeEnums.DISABLE;
                        let updateControlDevice = controlDeviceList[index];
                        if (updateControlDevice) {
                            let message = '';
                            if (mode === AlertModalModeEnums.ENABLE) {
                                message = `啟用 [ ${updateControlDevice.deviceName} ]`;
                            } else {
                                message = `停用 [ ${updateControlDevice.deviceName} ]`;
                            }
                            onEditControlDeviceStatus(mode, message, updateControlDevice.deviceId);
                        } else {
                            console.log('No device found at index:', index);
                        }
                    }
                });
            }
        }
    }, [needControlDeviceListLoad]);

    return (
        <div ref={ref}
            className="modal fade"
            id="modalControlDeviceList"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="modalControlDeviceListLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <form className="modal__form modal-content needs-validation" id="modalControlDeviceListForm">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="modalControlDeviceListLabel">
                            <div className="modal__title__badge">
                                <svg className="badge__icon" aria-hidden="true">
                                    <use href="#ico-settings-02"></use>
                                </svg>
                            </div>
                            <div className="modal__title__text">[{building?.buildingName}]梯控設定</div>
                        </h1>
                        <button type="button" className="btn-close btn-cancel" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div id="modal-mask" className="modal-mask"></div>
                        <div className="datatable__tool mb-2">
                            <div className="d-flex align-items-center gap-2 ms-auto">
                                {checkPermission(ModuleEnums.DEVICE, AccessModeEnums.CREATE) && (
                                <button type="button" className="btn btn-sm btn-primary" id="modalControlDeviceBtnNew" onClick={onNewControlDevice}>
                                    <svg className="btn__icon me-2" aria-hidden="true">
                                        <use href="#ico-plus"></use>
                                    </svg>
                                    新增
                                </button>
                                )}
                            </div>
                        </div>
                        <div className="datatable__data">
                            <table id="datatable__controlDeviceList" className="display table table-hover align-middle nowrap" style={{ width: '100%' }}></table>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
});

export default ControlDeviceListModal;